import { render, staticRenderFns } from "./terms-of-services.vue?vue&type=template&id=ecae1524&scoped=true"
import script from "./terms-of-services.vue?vue&type=script&lang=js"
export * from "./terms-of-services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecae1524",
  null
  
)

export default component.exports